// apex-quiz.js
// Apexzen Persona Quiz - State machine + submission + tracking
// Version 2.0.0 - 2026-10-10 (direction C : resultat sans email, email facultatif apres, 1 produit reel + Add to cart, dataLayer)
// Version 1.0.0 - 2026-05-22
// ASCII/cp1252 - no emoji - no jQuery
// Anti-boucle : 1 submission max par session (localStorage flag)

(function () {
  'use strict';

  // ============================================================
  // CONFIG
  // ============================================================

  var QUIZ_CONFIG_URL = window.Shopify
    ? window.Shopify.routes.root + 'cdn/shop/files/apex-quiz-config.json'
    : '/assets/apex-quiz-config.json';
  var STORAGE_KEY_STATE = 'apx_quiz_state_v1';
  var STORAGE_KEY_SUBMITTED = 'apx_quiz_submitted_v1';
  var MAX_RETRIES = 2;
  var SUBMIT_TIMEOUT_MS = 10000;
  var OPTION_ADVANCE_DELAY_MS = 260;

  var PILLAR_COLORS = {
    stress: '#2E6B52',
    sleep: '#2E6B52',
    perf: '#2E6B52',
    focus: '#2E6B52',
    cardio: '#2E6B52',
    'default': '#2E6B52'
  };

  // Direction C : produit de depart par chronotype (handle Shopify ; prix, variante, image lus dans
  // le JSON #apx-quiz-products rendu par Liquid). Alternatives = les autres produits du protocole.
  var START_PRODUCT = { ours: 'magnesium-glycinate', lion: 'primal-forge', loup: 'magnesium-glycinate', dauphin: 'ashwagandha-apex' };
  var STEP_HANDLES = {
    'Primal Forge': 'primal-forge', "Lion's Mane": 'lions-mane-mushroom', 'Magnesium Drift': 'magnesium-glycinate',
    'Reishi Reset Gummies': 'reishi-relax-gummies', 'Reishi Relax Gummies': 'reishi-relax-gummies',
    'Morning Reset Strips': 'morning-reset-strips', 'Ashwagandha Apex': 'ashwagandha-apex', 'Deep Reset': 'deep-reset',
    'Sleep Reset Strips': 'sleep-reset-strips', 'Reishi Calm Drops': 'reishi-calm-drops'
  };
  var PRODUCTS = {};
  try {
    var pj = document.getElementById('apx-quiz-products');
    if (pj) PRODUCTS = JSON.parse(pj.textContent) || {};
  } catch (e) { PRODUCTS = {}; }

  // ============================================================
  // UPSELL CATALOG - variant IDs reels Shopify (maj 2026-06-08, DEC-2026-06-08-003)
  // 3 mois pre-selectionne (levier AOV). Les 4 chronotypes sont ACTIFS :
  // packs 3/6 mois reactivees + publies (Boutique en ligne + Shop) le 08/06.
  // 1-mois ours/loup/dauphin = nouveaux produits actifs (anciens *-old archives).
  // ============================================================

  var DEFAULT_TIER = '3';

  var BUNDLE_CATALOG = {
    lion: {
      name: 'OURS Foundation Daily', handle: 'ours-foundation-daily', active: true, /* LION en brouillon 10/10 -> OURS */
      tiers: {
        '1': { variant: '53958755942733', price: 74.90,  label: '1 month' },
        '3': { variant: '53959387414861', price: 207.97, label: '3 months', save: '10% + free shipping' },
        '6': { variant: '53959393673549', price: 387.97, label: '6 months', save: '15% + shipping + bonus' }
      }
    },
    ours: {
      name: 'OURS Foundation Daily', handle: 'ours-foundation-daily', active: true,
      tiers: {
        '1': { variant: '54007708614989', price: 79.90,  label: '1 month' },
        '3': { variant: '53959385317709', price: 217.97, label: '3 months', save: '10% + free shipping' },
        '6': { variant: '53959390331213', price: 417.97, label: '6 months', save: '15% + shipping + bonus' }
      }
    },
    loup: {
      name: 'LOUP Night Edge', handle: 'loup-night-edge', active: true,
      tiers: {
        '1': { variant: '54008712855885', price: 84.90,  label: '1 month' },
        '3': { variant: '53959385973069', price: 229.97, label: '3 months', save: '10% + free shipping' },
        '6': { variant: '53959390855501', price: 439.97, label: '6 months', save: '15% + shipping + bonus' }
      }
    },
    dauphin: {
      name: 'DAUPHIN Reset Protocol', handle: 'dauphin-reset-protocol', active: true,
      tiers: {
        '1': { variant: '54008712888653', price: 119.90, label: '1 month' },
        '3': { variant: '53959386890573', price: 327.97, label: '3 months', save: '10% + free shipping' },
        '6': { variant: '53959393149261', price: 619.97, label: '6 months', save: '15% + shipping + bonus' }
      }
    }
  };

  // Add-on cross-sell : single SKU COMPLEMENTAIRE PAR CHRONOTYPE (jamais deja dans le pack).
  // Fix 2026-06-09 (Samuel) : avant = 1 seul Magnesium global = DOUBLON pour ours/loup/dauphin
  // (leur pack contient deja Magnesium Drift). Mapping DEC-2026-06-08-001/003 + verif compo packs :
  // lion (pas de Mg dans le pack) -> Magnesium Drift (offre irresistible) ; autres -> single adapte hors pack.
  var ADDON_BY_CHRONO = {
    lion:    { name: 'Magnesium Drift',    handle: 'magnesium-glycinate',    variant: '51516636692813', price: 29.90, blurb: 'Add Magnesium Drift for deeper recovery and sleep onset.' },
    ours:    { name: 'Creatine Surge',     handle: 'creatine-surge',     variant: '53821369090381', price: 39.90, blurb: 'Add Creatine Surge for strength and cognitive output, the daily compounding edge.' },
    loup:    { name: 'Sleep Reset Strips', handle: 'sleep-reset-strips', variant: '53886537630029', price: 36.50, blurb: 'Add Sleep Reset Strips for fast sleep onset on the nights your brain will not switch off. No water needed.' },
    dauphin: { name: '5-HTP Serene',       handle: '5-htp',              variant: '53823372198221', price: 26.90, blurb: 'Add 5-HTP Serene to support mood and serotonin, the missing layer in the wired-but-tired loop.' }
  };

  // ============================================================
  // CHRONO_RESULT - content-model du tunnel resultat (valeur-d-abord)
  // Langage Marcus + loss aversion. Protocole = compositions reelles Shopify.
  // Zero invention de dosage/chiffre. AUCUN faux avis (0 client reel).
  // Source = prototype CHRONOTYPE_TUNNEL_PREVIEW.html (objet DATA, valide Samuel 2026-06-08).
  // mirror = fallback generique (utilise si quiz_answers indisponible) ; sinon assemble
  // dynamiquement depuis les vraies reponses via buildMirror().
  // ============================================================

  var CHRONO_RESULT = {
    ours: {
      animal: 'Bear',
      type_line: 'you run on a <span class="apx-tunnel__type">Bear</span> rhythm, and right now it is leaking.',
      mirror: 'You carry a full load at work and at home, and by the time the day is finally quiet, your mind will not switch off. You do not need a wearable to feel that your edge is slipping.',
      body: 'By the time the day winds down and you finally open the laptop, your stress switch is still on. That switch is cortisol, the hormone that is supposed to drop at night so your brain can power down. Yours stays high. So your mind keeps running, you fall asleep too late, and you snap awake around 3am. Eight hours in bed, but your brain never reaches the deep part that rebuilds focus. The focus you want is the exact thing this is stealing.',
      cost: 'Left alone, this does not stay flat, it compounds. Another quarter of 70% mornings, a shorter fuse with your team and the people at home, and the edge that used to make you the sharpest person in the room getting a little duller. You have probably already spent a few hundred dollars on random magnesium and melatonin that did nothing. The real cost is not the supplements. It is the version of you that shows up at 70%.',
      steps: [
        { when: 'Morning', name: 'Primal Forge', benefit: 'Sets your drive for the day so your energy does not crater after lunch.' },
        { when: 'Daytime', name: "Lion's Mane", benefit: 'The focus piece. Keeps your head clear through the afternoon block.' },
        { when: 'Before bed', name: 'Magnesium Drift', benefit: 'Switches off the stress signal so your brain finally powers down and you get the deep sleep that rebuilds focus.' }
      ],
      why: 'You do not need to be knocked out. You need your nights to actually repair you, so your days run at full power. <b>Drive in the morning, focus through the day, real recovery at night.</b> That is the whole protocol.',
      voc: '"I do not need to feel knocked out. I need to feel ready."'
    },
    lion: {
      animal: 'Lion',
      type_line: 'you run on a <span class="apx-tunnel__type">Lion</span> rhythm, and the late nights are taxing the early mornings.',
      mirror: 'You are up before most people, you train early, and you are often out late building relationships. High ceiling. The problem is the floor: the schedule quietly eats your recovery.',
      body: 'You burn hot from 5:30am. But the networking dinners and the travel keep your system switched on past midnight, so you never fully recover before the alarm goes again. Over weeks, the early energy that defines you starts arriving late and leaving early.',
      cost: 'Keep running it like this and the mornings that are your weapon turn average. The training plateaus, the presence in the room dips, and you start leaning on a fourth coffee to fake what used to be natural. That is the trade you are making without deciding to.',
      steps: [
        { when: 'Morning', name: 'Primal Forge', benefit: 'Holds your energy floor high for early training and a long day.' },
        { when: 'Evening', name: 'Reishi Reset Gummies', benefit: 'Calm and recovery, so the late nights do not cost you tomorrow.' },
        { when: 'As needed', name: 'Morning Reset Strips', benefit: 'Fast support for the mornings after a networking night.' }
      ],
      why: 'Your edge is the early hours. <b>This protects them.</b> Keep the morning floor high, and buy back the recovery your schedule keeps stealing.',
      voc: '"I sleep, and still wake up tired. That is the real problem."'
    },
    loup: {
      animal: 'Wolf',
      type_line: 'you run on a <span class="apx-tunnel__type">Wolf</span> rhythm, and your nights are not recovering you.',
      mirror: 'Your sharpest hours are late, after 2pm, when everyone else is fading. The cost shows up at night: your sleep is shallow and broken, and it follows you into a foggy morning.',
      body: 'You peak late, which means your brain is still wired when your head hits the pillow. So you drift in and out, never sinking into the deep sleep that clears your head. You wake up feeling like you never really switched off, because you did not.',
      cost: 'Every week you let this run, you lose deep sleep you do not get back. The morning fog gets a little thicker, the afternoons you rely on get a little shorter, and the gap between how sharp you feel you should be and how you actually feel keeps widening.',
      steps: [
        { when: 'With dinner', name: "Lion's Mane", benefit: 'Works overnight so you wake up clearer.' },
        { when: 'Pre-bed', name: 'Reishi Relax Gummies', benefit: 'Helps your nervous system actually wind down.' },
        { when: 'Before bed', name: 'Magnesium Drift', benefit: 'Deeper, less interrupted sleep. No melatonin dependency, no next-day fog.' }
      ],
      why: 'This protocol is built around your weak spot, the night. <b>Wind down, sleep deep, wake up clear.</b> No knockout, no grogginess.',
      voc: '"I am not stressed about work. I am stressed because I cannot shut my brain off."'
    },
    dauphin: {
      animal: 'Dolphin',
      type_line: 'you run on a <span class="apx-tunnel__type">Dolphin</span> rhythm, with the stress dial stuck on high.',
      mirror: 'You are wired but tired. Your system cannot downshift, your sleep is broken, and the stress never fully switches off. This is the burnout pattern, and you already know one pill will not fix it.',
      body: 'Your stress hormone is supposed to rise in the morning and fall at night. Yours stays elevated around the clock, so your body never gets the signal that it is safe to rest. You fall asleep late, wake up often, and never get the deep repair, which keeps the stress high. It is a loop.',
      cost: 'This is the pattern that does not just stall a quarter, it breaks people. The irritability, the Sunday dread, the feeling of being a fraud between the high-performer you project and the exhausted person you are. Every month you wait, the loop digs in deeper and takes longer to reverse.',
      steps: [
        { when: 'Daily', name: 'Ashwagandha Apex', benefit: 'Brings the stress dial back down, the root of the wired-but-tired loop.' },
        { when: 'With dinner', name: 'Magnesium Drift', benefit: 'Starts rebuilding sleep depth.' },
        { when: 'Before bed', name: 'Deep Reset', benefit: 'Helps you fall asleep without forcing it.' },
        { when: 'Pre-bed', name: 'Sleep Reset Strips', benefit: 'Fast, no water needed.' },
        { when: 'As needed', name: 'Reishi Calm Drops', benefit: 'For the moments the system spikes.' }
      ],
      why: 'This is a <b>60 to 90 day rebuild, not a knockout.</b> Bring the stress down by day, restore real sleep by night, across several paths so no single one has to carry it all.',
      voc: '"I tried magnesium. I tried melatonin. I tried CBD. Then I gave up. I want to come back."'
    }
  };

  // ============================================================
  // STATE
  // ============================================================

  var state = {
    currentStep: 1,
    totalSteps: 8,
    answers: {},
    scores: { marcus: 0, jessica: 0, david: 0, sarah: 0, waitlist_prenat: 0 },
    chronotype: null,
    personaId: null,
    email: null,
    firstName: '',
    retryCount: 0,
    config: null,
    webhookUrl: '',
    startedAt: Date.now(),
    resultShown: false,
    started: false
  };

  // ============================================================
  // DOM REFERENCES
  // ============================================================

  var elFlow = document.getElementById('apx-quiz-flow');
  var elQuestions = document.getElementById('apx-quiz-questions');
  var elGate = document.getElementById('apx-quiz-gate');
  var elResultWrap = document.getElementById('apx-quiz-result-wrap');
  var elError = document.getElementById('apx-quiz-error');
  var elErrorMsg = document.getElementById('apx-quiz-error-msg');
  var elRetryBtn = document.getElementById('apx-quiz-retry-btn');
  var elProgressBar = document.getElementById('apx-quiz-progress-bar');
  var elProgressLabel = document.getElementById('apx-quiz-progress-label');
  var elGateForm = document.getElementById('apx-quiz-gate-form');
  var elEmailInput = document.getElementById('apx-quiz-email-input');
  var elEmailError = document.getElementById('apx-quiz-email-error');
  var elGateSubmit = document.getElementById('apx-quiz-gate-submit');
  var elGateDone = document.getElementById('apx-quiz-gate-done');

  // ============================================================
  // INIT
  // ============================================================

  function init() {
    if (!elFlow) return;

    state.webhookUrl = elFlow.dataset.webhook || '';

    // Anti-boucle : si deja soumis cette session, afficher resultat cached
    var submitted = safeLocalStorageGet(STORAGE_KEY_SUBMITTED);
    if (submitted && submitted.persona_id) {
      // Restaurer le profil pour personnaliser le verdict apres reload.
      if (submitted.answers) state.answers = submitted.answers;
      if (submitted.first_name) state.firstName = submitted.first_name;
      state.personaId = submitted.persona_id;
      state.chronotype = submitted.chronotype || null;
      renderResult(submitted.persona_id, submitted.chronotype || null, submitted.email || '');
      if (submitted.email) showGateDone();
      return;
    }

    // Charger config JSON quiz
    fetchConfig(function (config) {
      state.config = config;
      // Tenter reprise depuis localStorage
      var saved = safeLocalStorageGet(STORAGE_KEY_STATE);
      if (saved && saved.currentStep && saved.answers) {
        state.currentStep = saved.currentStep;
        state.answers = saved.answers;
        state.scores = saved.scores || state.scores;
        state.chronotype = saved.chronotype || null;
      }
      renderStep(state.currentStep);
    });

    if (elRetryBtn) {
      elRetryBtn.addEventListener('click', function () {
        hideError();
        state.retryCount = 0;
        var cEl2 = document.getElementById('apx-quiz-consent-marketing');
        submitQuiz(state.email, cEl2 ? cEl2.checked : false);
      });
    }

    if (elGateForm) {
      elGateForm.addEventListener('submit', handleGateSubmit);
    }
  }

  // ============================================================
  // CONFIG FETCH
  // ============================================================

  function fetchConfig(callback) {
    var url = '/assets/apex-quiz-config.json';
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.timeout = 5000;
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          callback(JSON.parse(xhr.responseText));
        } catch (e) {
          callback(getInlineFallbackConfig());
        }
      } else {
        callback(getInlineFallbackConfig());
      }
    };
    xhr.onerror = function () { callback(getInlineFallbackConfig()); };
    xhr.ontimeout = function () { callback(getInlineFallbackConfig()); };
    xhr.send();
  }

  // ============================================================
  // RENDER STEP
  // ============================================================

  function renderStep(stepIndex) {
    updateProgress(stepIndex);

    if (stepIndex >= state.totalSteps) {
      showResultNow();
      return;
    }

    var questionIndex = stepIndex - 1;
    if (!state.config || !state.config.questions || !state.config.questions[questionIndex]) {
      return;
    }

    renderQuestion(state.config.questions[questionIndex], stepIndex);
  }

  function renderQuestion(q, stepIndex) {
    showQuestions();

    var elStepLabel = document.getElementById('apx-q-step-label');
    var elLabel = document.getElementById('apx-q-label');
    var elSublabel = document.getElementById('apx-q-sublabel');
    var elOptions = document.getElementById('apx-q-options');
    var elSlot = document.getElementById('apx-quiz-question-slot');

    if (!elLabel || !elOptions) return;

    if (elStepLabel) elStepLabel.textContent = 'Question ' + stepIndex;
    if (!state.started) { state.started = true; pushDL('quiz_start', { step: stepIndex }); }
    elLabel.textContent = q.label || '';
    if (elSublabel) elSublabel.textContent = q.sublabel || '';
    if (elSlot) elSlot.setAttribute('data-step', stepIndex);

    // Pillar color progression
    var pillarKey = stepToPillar(stepIndex);
    // Q6: utilise le pilier de l'option selectionnee si disponible
    if (q.id === 'q6' && state.answers['q6']) {
      var matchOpt = findOption(q.options, state.answers['q6']);
      if (matchOpt && matchOpt.pillar) pillarKey = matchOpt.pillar;
    }
    setPillarColor(pillarKey);

    // Render options
    elOptions.innerHTML = '';
    (q.options || []).forEach(function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'apx-quiz-option' + (state.answers[q.id] === opt.id ? ' apx-quiz-option--selected' : '');
      btn.setAttribute('data-option-id', opt.id);
      btn.setAttribute('data-question-id', q.id);
      btn.textContent = opt.label;
      btn.addEventListener('click', function () { handleOptionSelect(q, opt); });
      elOptions.appendChild(btn);
    });

    // Fade in animation
    elOptions.classList.remove('apx-quiz-fade-in');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        elOptions.classList.add('apx-quiz-fade-in');
      });
    });

    // Tracking
    trackEvent('quiz_question_viewed', { step: stepIndex, question_id: q.id });
  }

  function stepToPillar(step) {
    if (step <= 2) return 'stress';
    if (step <= 4) return 'sleep';
    if (step <= 6) return 'focus';
    return 'perf';
  }

  function findOption(options, optionId) {
    if (!options) return null;
    for (var i = 0; i < options.length; i++) {
      if (options[i].id === optionId) return options[i];
    }
    return null;
  }

  // ============================================================
  // OPTION SELECT
  // ============================================================

  function handleOptionSelect(q, opt) {
    // Enregistrer reponse
    state.answers[q.id] = opt.id;

    // Accumuler scores
    if (opt.weight && typeof opt.weight === 'object') {
      Object.keys(opt.weight).forEach(function (key) {
        if (typeof state.scores[key] === 'number') {
          state.scores[key] += (typeof opt.weight[key] === 'number' ? opt.weight[key] : 0);
        }
      });
    }

    // Chronotype si Q4
    if (q.id === 'q4' && opt.chronotype) {
      state.chronotype = opt.chronotype;
    }

    // Force path Q2 pregnant : skip Q3-Q7, aller directement au gate
    if (q.id === 'q2' && opt.id === 'pregnant') {
      state.scores.waitlist_prenat = 99;
      state.personaId = 'waitlist_prenat';
      state.currentStep = state.totalSteps;
      saveState();
      // Visual feedback puis transition
      markSelected(opt.id);
      setTimeout(function () { renderStep(state.currentStep); }, OPTION_ADVANCE_DELAY_MS);
      return;
    }

    // Avancer a la question suivante
    state.currentStep++;
    saveState();

    markSelected(opt.id);

    // Tracking
    trackEvent('quiz_question_answered', { step: state.currentStep - 1, question_id: q.id, option_id: opt.id });
    pushDL('quiz_step', { step: state.currentStep - 1, question_id: q.id });

    setTimeout(function () {
      renderStep(state.currentStep);
    }, OPTION_ADVANCE_DELAY_MS);
  }

  function markSelected(optionId) {
    var opts = document.querySelectorAll('.apx-quiz-option');
    for (var i = 0; i < opts.length; i++) {
      opts[i].classList.remove('apx-quiz-option--selected');
      if (opts[i].getAttribute('data-option-id') === optionId) {
        opts[i].classList.add('apx-quiz-option--selected');
      }
    }
  }

  // ============================================================
  // EMAIL GATE
  // ============================================================

  // Direction C : la question 7 repondue, le resultat s'affiche tout de suite. Aucun email demande avant.
  function showResultNow() {
    if (!state.personaId) state.personaId = resolvePersona();
    if (!state.chronotype) state.chronotype = 'ours';
    trackEvent('quiz_completed', { persona_id: state.personaId, chronotype: state.chronotype });
    pushDL('quiz_complete', { chronotype: state.chronotype });
    renderResult(state.personaId, state.chronotype, '');
  }

  function showGateAfterResult() {
    if (!elGate) return;
    elGate.hidden = false;
    // Le formulaire email se place sous le resultat, dans le flux de lecture.
    if (elResultWrap && elGate.parentNode === elResultWrap.parentNode && elResultWrap.nextSibling !== elGate) {
      elResultWrap.parentNode.insertBefore(elGate, elResultWrap.nextSibling);
    }
  }

  function showGateDone() {
    if (elGateForm) elGateForm.hidden = true;
    if (elGateDone) elGateDone.hidden = false;
    if (elGate) elGate.hidden = false;
  }

  function handleGateSubmit(e) {
    e.preventDefault();

    // Honeypot check
    var hp = elGateForm ? elGateForm.querySelector('input[name="website"]') : null;
    if (hp && hp.value && hp.value.length > 0) {
      // Bot detected - silent fake success
      showResultFakeSuccess();
      return;
    }

    var email = elEmailInput ? elEmailInput.value.trim() : '';
    if (!validateEmail(email)) {
      showEmailError('Please enter a valid email address.');
      return;
    }
    hideEmailError();

    var consentEl = document.getElementById('apx-quiz-consent-marketing');
    var consent = consentEl ? consentEl.checked : false;

    state.email = email;
    if (!state.personaId) {
      state.personaId = resolvePersona();
    }

    // Anti-boucle : deja envoye a cette adresse -> on confirme sans renvoyer
    var submitted = safeLocalStorageGet(STORAGE_KEY_SUBMITTED);
    if (submitted && submitted.email === email) {
      showGateDone();
      return;
    }

    setGateLoading(true);
    submitQuiz(email, consent);
  }

  // ============================================================
  // PERSONA RESOLUTION
  // ============================================================

  function resolvePersona() {
    var s = state.scores;

    if (s.waitlist_prenat >= 5) return 'waitlist_prenat';
    if (s.marcus >= 7) return 'marcus';
    if (s.sarah >= 5) return 'sarah';
    // Default V1 = marcus (DTC-first, seul path actif V1)
    return 'marcus';
  }

  // ============================================================
  // SUBMISSION
  // ============================================================

  function submitQuiz(email, consentMarketing) {
    if (typeof consentMarketing === 'undefined') consentMarketing = false;

    var webhookUrl = state.webhookUrl;
    if (!webhookUrl) {
      showError('Configuration error. Please contact support.');
      return;
    }

    var timeSpent = Math.round((Date.now() - state.startedAt) / 1000);

    var payload = {
      email: email,
      first_name: state.firstName || '',
      persona_routing_id: state.personaId || 'marcus',
      quiz_answers: state.answers,
      result_chronotype: state.chronotype || 'ours',
      result_bundle_slug: getBundleSlug(state.personaId, state.chronotype),
      result_score: state.scores,
      time_spent_seconds: timeSpent,
      device: getDevice(),
      utm_source: getUrlParam('utm_source'),
      utm_campaign: getUrlParam('utm_campaign'),
      lang: document.documentElement.lang || 'en',
      consent_marketing: consentMarketing
    };

    var timeoutId = null;
    var xhr = new XMLHttpRequest();

    timeoutId = setTimeout(function () {
      xhr.abort();
      handleSubmitError('timeout');
    }, SUBMIT_TIMEOUT_MS);

    xhr.open('POST', webhookUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onload = function () {
      clearTimeout(timeoutId);
      if (xhr.status >= 200 && xhr.status < 300) {
        // Sauvegarder flag anti-boucle
        safeLocalStorageSet(STORAGE_KEY_SUBMITTED, {
          email: email,
          persona_id: state.personaId,
          chronotype: state.chronotype,
          answers: state.answers,
          first_name: state.firstName || '',
          ts: Date.now()
        });
        // Nettoyer state de progression
        safeLocalStorageSet(STORAGE_KEY_STATE, null);
        // Tracking (sans donnee personnelle)
        trackEvent('quiz_email_submitted', {
          persona_id: state.personaId,
          chronotype: state.chronotype,
          time_spent_seconds: timeSpent,
          consent_marketing: !!consentMarketing
        });
        pushDL('quiz_email_submit', { chronotype: state.chronotype, consent_marketing: !!consentMarketing });
        setGateLoading(false);
        showGateDone();
        // Prenatal : l'opt-in (date prevue) n'est propose qu'une fois l'email connu.
        if (state.personaId === 'waitlist_prenat' && window.apxPrenatalInit) {
          window.apxPrenatalInit(email, state.firstName || null);
        }
      } else {
        handleSubmitError('http_' + xhr.status);
      }
    };

    xhr.onerror = function () {
      clearTimeout(timeoutId);
      handleSubmitError('network_error');
    };

    xhr.send(JSON.stringify(payload));
  }

  function handleSubmitError(reason) {
    setGateLoading(false);
    state.retryCount++;
    if (state.retryCount <= MAX_RETRIES) {
      var delay = state.retryCount === 1 ? 1000 : 3000;
      setTimeout(function () {
        setGateLoading(true);
        var cEl = document.getElementById('apx-quiz-consent-marketing');
        submitQuiz(state.email, cEl ? cEl.checked : false);
      }, delay);
    } else {
      showError('We could not process your request. Please try again in a moment.');
    }
  }

  // ============================================================
  // RESULT RENDER
  // ============================================================

  function renderResult(personaId, chronotype, email) {
    if (elQuestions) elQuestions.hidden = true;
    if (elResultWrap) elResultWrap.hidden = false;
    state.resultShown = true;

    updateProgress(8, true);
    setPillarColor('stress');

    var elMarcus = document.getElementById('apx-result-marcus');
    var elWaitlist = document.getElementById('apx-result-waitlist');

    if (personaId === 'marcus') {
      if (elMarcus) {
        elMarcus.hidden = false;
        renderMarcusResult(chronotype || 'ours');
      }
      if (elWaitlist) elWaitlist.hidden = true;
    } else {
      if (elWaitlist) {
        elWaitlist.hidden = false;
        var emailLine = document.getElementById('apx-result-waitlist-email');
        if (emailLine) emailLine.textContent = '';
        // Prenatal : l'opt-in n'est revele qu'apres un email donne (voir submitQuiz).
        if (personaId === 'waitlist_prenat' && email && window.apxPrenatalInit) {
          window.apxPrenatalInit(email, state.firstName || null);
        }
      }
      if (elMarcus) elMarcus.hidden = true;
    }

    showGateAfterResult();
    trackEvent('quiz_result_viewed', { persona_id: personaId, chronotype: chronotype });
    pushDL('quiz_result_view', { chronotype: chronotype || '' });
  }

  // Assemble le verdict-miroir depuis les VRAIES reponses du quiz (role, enfants,
  // objectif, wearable). Fallback generique si les reponses sont indisponibles.
  function buildMirror(ans, fallback) {
    if (!ans || !ans.q1) return fallback;
    var roleMap = {
      vp_director: 'you run a team as a <b>VP</b>',
      founder_ceo: 'you run your own company as a <b>founder</b>',
      senior_ic: 'you carry the technical load as a <b>senior IC</b>',
      pre50_longevity: 'you are playing the <b>long game</b> on your health'
    };
    var kidsMap = { yes_under5: 'you have <b>young kids at home</b>' };
    var goalMap = {
      stress_recovery: 'to <b>lower the stress and recover faster</b>',
      sleep_quality: '<b>deeper sleep</b>',
      focus_energy: 'your <b>focus and energy</b>',
      longevity_base: 'a <b>longevity baseline</b>'
    };
    var wearMap = {
      yes_oura_whoop: 'You already track it with a ring, so you have watched the numbers slip.',
      yes_apple: 'You track it on your watch, so you have watched the numbers slip.',
      no_wearable: 'You do not track your sleep yet, but you do not need a ring to feel it.'
    };
    var parts = [];
    if (roleMap[ans.q1]) parts.push(roleMap[ans.q1]);
    if (kidsMap[ans.q5]) parts.push(kidsMap[ans.q5]);
    if (!parts.length) return fallback;
    var s = 'Here is what you told us: ' + parts.join(', ');
    var goal = goalMap[ans.q6];
    s += goal ? (', and the thing you want back most is ' + goal + '.') : '.';
    var w = wearMap[ans.q3];
    if (w) s += ' ' + w;
    return s;
  }

  function escapeHtml(str) {
    return String(str).replace(/[<>&"]/g, function (c) {
      return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c];
    });
  }

  function capitalizeFirst(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : str;
  }

  // Resultat resolu server-side -> tunnel valeur-d-abord (6 sections a..f).
  function renderMarcusResult(chronotype) {
    var elStacks = document.getElementById('apx-result-stacks');

    var key = CHRONO_RESULT[chronotype] ? chronotype : 'ours';
    var d = CHRONO_RESULT[key];
    var entry = BUNDLE_CATALOG[key] || BUNDLE_CATALOG['lion'];

    // Couleur pilier du chronotype (reutilisee par le tunnel + l'offre)
    var pillarByChrono = { lion: 'perf', ours: 'stress', loup: 'focus', dauphin: 'cardio' };
    setPillarColor(pillarByChrono[key] || 'stress');

    injectTunnelStyles();
    injectUpsellStyles();

    // Widen the result column (the question flow is intentionally 640px).
    var quizInner = document.querySelector('.apx-quiz-flow__inner');
    if (quizInner) quizInner.classList.add('is-result-wide');

    // Masquer l'en-tete statique liquid (eyebrow + h2 + ligne chronotype) et la CTA FC
    // statique : le tunnel porte son propre titre, sa preuve et son offre.
    var marcusEl = document.getElementById('apx-result-marcus');
    if (marcusEl) {
      var hdr = marcusEl.querySelector('.apx-quiz-result__header');
      if (hdr) hdr.style.display = 'none';
      var fcCta = marcusEl.querySelector('.apx-quiz-result__fc-cta');
      if (fcCta) fcCta.style.display = 'none';
    }

    // (a) VERDICT personnalise
    var nm = state.firstName ? escapeHtml(state.firstName) : '';
    var headline = nm ? (nm + ', ' + d.type_line) : capitalizeFirst(d.type_line);
    var mirror = buildMirror(state.answers, d.mirror);

    // (d) Protocole
    var stepsHtml = d.steps.map(function (s) {
      return '<div class="apx-tunnel__step"><div class="apx-tunnel__when">' + s.when + '</div>'
        + '<div><p class="apx-tunnel__compound">' + s.name + '</p>'
        + '<p class="apx-tunnel__benefit">' + s.benefit + '</p></div></div>';
    }).join('');

    // (e) Preuve HONNETE (zero faux avis)
    var proofHtml = ''
      + '<div><b>Full Supplement Facts</b>Every product page shows the label: ingredient, form, amount per serving. When a formula uses a blend, the page says so.</div>'
      + '<div><b>FDA-registered facility, cGMP</b>Manufactured in an FDA-registered facility under current Good Manufacturing Practices.</div>'
      + '<div><b>30-day money-back</b>No restocking fee. Email from the address you ordered with.</div>'
      + '<div><b>Shipping in writing</b>Free US shipping over $75, $5.99 under.</div>';

    // (f) Offre : UN produit reel, prix et variante lus dans le JSON Liquid. Alternatives = autres produits du protocole.
    var startHandle = START_PRODUCT[key] || 'magnesium-glycinate';
    var startP = PRODUCTS[startHandle] || null;
    var altHtml = '';
    var altCount = 0;
    d.steps.forEach(function (st) {
      var h = STEP_HANDLES[st.name];
      var pr = h ? PRODUCTS[h] : null;
      if (!pr || h === startHandle || altCount >= 2) return;
      altCount++;
      altHtml += '<a class="apx-tunnel__alt" href="' + pr.url + '"><span class="apx-tunnel__alt-name">' + escapeHtml(pr.title) + '</span>'
        + (pr.fact ? '<span class="apx-tunnel__alt-fact">' + pr.fact + '</span>' : '')
        + '<span class="apx-tunnel__alt-price">' + escapeHtml(pr.price) + '</span></a>';
    });
    var packP = PRODUCTS[entry.handle] || null;
    var offerBody = '';
    if (startP) {
      offerBody += '<div class="apx-tunnel__start">'
        + (startP.image ? '<a class="apx-tunnel__start-media" href="' + startP.url + '"><img src="' + startP.image + '" alt="' + escapeHtml(startP.title) + '" width="240" height="240" loading="lazy"></a>' : '')
        + '<div class="apx-tunnel__start-body">'
        + '<p class="apx-tunnel__start-lead">Start with</p>'
        + '<p class="apx-tunnel__offer-name"><a href="' + startP.url + '">' + escapeHtml(startP.title) + '</a></p>'
        + (startP.fact ? '<p class="apx-tunnel__start-fact">' + startP.fact + '</p>' : '')
        + '<p class="apx-tunnel__price">' + escapeHtml(startP.price) + '</p>'
        + (startP.available
            ? '<button type="button" class="apx-cta-primary apx-upsell__cta" id="apx-upsell-cta" data-variant="' + startP.variant + '">Add to cart &middot; ' + escapeHtml(startP.price) + '</button>'
            : '<a class="apx-btn-secondary" href="' + startP.url + '">View product</a>')
        + '</div></div>';
    }
    if (altHtml) offerBody += '<p class="apx-tunnel__sec-h" style="margin-top:18px">Also in your protocol</p><div class="apx-tunnel__alts">' + altHtml + '</div>';
    if (packP) offerBody += '<p class="apx-tunnel__micro">Want the whole routine in one box? <a href="' + packP.url + '">' + escapeHtml(packP.title) + ' &middot; ' + escapeHtml(packP.price) + '</a></p>';
    offerBody += '<span class="apx-tunnel__micro">Your result stays on this page. Email it to yourself below if you want to keep it.</span>';

    var html = '<div class="apx-tunnel" data-chronotype="' + key + '">'
      + '<p class="apx-tunnel__eyebrow">Your Apex Index result</p>'
      + '<h1 class="apx-tunnel__h1">' + headline + '</h1>'
      + '<p class="apx-tunnel__mirror">' + mirror + '</p>'
      + '<div class="apx-tunnel__body"><h3>What is actually happening</h3><p>' + d.body + '</p></div>'
      + '<div class="apx-tunnel__cost"><b>And if nothing changes:</b> ' + d.cost + '</div>'

      + '<div class="apx-tunnel__rule"></div>'
      + '<p class="apx-tunnel__sec-h">Your protocol</p>'
      + '<p class="apx-tunnel__sec-sub">' + d.steps.length + ' things, sequenced to your day. No jargon, no guesswork.</p>'
      + '<div class="apx-tunnel__timeline">' + stepsHtml + '</div>'
      + '<p class="apx-tunnel__why">' + d.why + '</p>'

      + '<div class="apx-tunnel__rule"></div>'
      + '<p class="apx-tunnel__sec-h">Why you can trust this</p>'
      + '<div class="apx-tunnel__proof">' + proofHtml + '</div>'
      + '<p class="apx-tunnel__voc">' + d.voc + '</p>'
      + '<p class="apx-tunnel__honest">These are not customer reviews. We have not launched yet, so we will not fake them. The quote above is from the research that built this protocol. Real founder reviews land here as the first 100 run it.</p>'

      + '<div class="apx-tunnel__offer"><div class="apx-tunnel__offer-head"><p class="apx-tunnel__offer-lead">Where to begin</p></div>'
      + '<div class="apx-tunnel__offer-body">' + offerBody + '</div></div>'

      + '<p class="apx-tunnel__disc">*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease. Talk to your physician before starting any supplement, especially if you take medication.</p>'
      + '</div>';

    elStacks.innerHTML = html;

    // Tracking : protocole vu AVANT l'offre.
    trackEvent('quiz_protocol_viewed', { chronotype: key, bundle: entry.handle, active: entry.active });

    var ctaEl = document.getElementById('apx-upsell-cta');
    if (ctaEl) {
      ctaEl.addEventListener('click', function () {
        addStartProductToCart(ctaEl, startHandle);
      });
    }

    trackEvent('quiz_upsell_viewed', { chronotype: key, active: entry.active });
  }

  // ============================================================
  // ADD TO CART (Shopify AJAX /cart/add.js -> straight to checkout,
  // email prefilled from the quiz so the buyer never retypes it)
  // ============================================================

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function addStartProductToCart(btn, handle) {
    var pr = PRODUCTS[handle];
    if (!pr || !pr.variant) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    trackEvent('quiz_add_to_cart', { chronotype: state.chronotype, handle: handle });
    pushDL('quiz_add_to_cart', { chronotype: state.chronotype || '', handle: handle });
    var xhr = new XMLHttpRequest();
    xhr.open('POST', cartRoot() + 'cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        window.location.href = cartRoot() + 'cart';
      } else {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        window.location.href = pr.url;
      }
    };
    xhr.onerror = function () { window.location.href = pr.url; };
    xhr.send(JSON.stringify({ items: [{ id: Number(pr.variant), quantity: 1 }] }));
  }

  // ============================================================
  // TUNNEL STYLES (resultat valeur-d-abord, injectes une fois)
  // ============================================================

  function injectTunnelStyles() {
    if (document.getElementById('apx-tunnel-styles')) return;
    var css = ''
      + '.apx-tunnel{max-width:720px;margin:0 auto;text-align:left;color:#1F2A24;line-height:1.6}'
      + '.apx-tunnel__eyebrow{font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#2E6B52;font-weight:500;font-family:var(--apx-font-mono,monospace);margin:0 0 12px}'
      + '.apx-tunnel__h1{font-size:28px;line-height:1.15;margin:0 0 14px;letter-spacing:-.01em}'
      + '.apx-tunnel__type{color:var(--apx-quiz-pillar,#1A4A90)}'
      + '.apx-tunnel__mirror{font-size:16px;margin:0 0 18px}'
      + '.apx-tunnel__mirror b{color:#1F2A24}'
      + '.apx-tunnel__body{background:#EDF2EC;border-radius:13px;padding:17px 18px;margin:0 0 14px}'
      + '.apx-tunnel__body h3{font-size:12px;letter-spacing:.07em;text-transform:uppercase;color:#52605A;margin:0 0 7px}'
      + '.apx-tunnel__body p{margin:0;font-size:15.5px}'
      + '.apx-tunnel__cost{border-left:3px solid var(--apx-quiz-pillar,#1A4A90);background:rgba(46,107,82,.08);padding:13px 16px;border-radius:0 11px 11px 0;margin:0 0 8px;font-size:15.5px}'
      + '.apx-tunnel__cost b{color:#1F2A24}'
      + '.apx-tunnel__rule{height:1px;background:#DCE3DC;margin:24px 0}'
      + '.apx-tunnel__sec-h{font-size:12.5px;letter-spacing:.12em;text-transform:uppercase;font-weight:700;margin:0 0 4px}'
      + '.apx-tunnel__sec-sub{font-size:14px;color:#52605A;margin:0 0 16px}'
      + '.apx-tunnel__timeline{display:flex;flex-direction:column}'
      + '.apx-tunnel__step{display:grid;grid-template-columns:92px 1fr;gap:14px;padding:13px 0;border-bottom:1px dashed #DCE3DC}'
      + '.apx-tunnel__step:last-child{border-bottom:0}'
      + '.apx-tunnel__when{font-size:11.5px;font-weight:700;color:var(--apx-quiz-pillar,#1A4A90);text-transform:uppercase;letter-spacing:.03em;padding-top:2px}'
      + '.apx-tunnel__compound{font-weight:650;font-size:15.5px;margin:0 0 2px}'
      + '.apx-tunnel__benefit{font-size:14.5px;color:#52605A;margin:0}'
      + '.apx-tunnel__why{font-size:15.5px;margin:16px 0 0;padding:14px 16px;background:#EDF2EC;border-radius:11px}'
      + '.apx-tunnel__why b{color:#1F2A24}'
      + '.apx-tunnel__proof{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin:18px 0 0}'
      + '.apx-tunnel__proof div{border:1px solid #DCE3DC;border-radius:11px;padding:12px 13px;font-size:13.5px;background:#fff}'
      + '.apx-tunnel__proof b{display:block;color:#1F2A24;font-size:14px;margin-bottom:2px}'
      + '.apx-tunnel__voc{margin:18px 0 0;font-style:italic;font-size:15.5px;border-left:3px solid #2E6B52;padding:4px 0 4px 15px}'
      + '.apx-tunnel__start{display:grid;grid-template-columns:120px 1fr;gap:16px;align-items:start}'
      + '.apx-tunnel__start-media{display:block;background:#fff;border:1px solid #DCE3DC;border-radius:14px;overflow:hidden}'
      + '.apx-tunnel__start-media img{width:100%;height:auto;aspect-ratio:1/1;object-fit:contain;display:block}'
      + '.apx-tunnel__start-lead{font-size:13px;color:#52605A;margin:0 0 2px}'
      + '.apx-tunnel__start-fact{font-size:14px;color:#52605A;margin:4px 0 6px}'
      + '.apx-tunnel__price{font-family:var(--apx-font-mono,monospace);font-size:22px;font-weight:500;margin:0 0 12px;color:#1F2A24}'
      + '.apx-tunnel__offer-name a{text-decoration:none;color:inherit}'
      + '.apx-tunnel__alts{display:grid;grid-template-columns:1fr 1fr;gap:10px}'
      + '.apx-tunnel__alt{display:flex;flex-direction:column;gap:3px;border:1px solid #DCE3DC;border-radius:14px;padding:12px 13px;text-decoration:none;color:#1F2A24;background:#fff}'
      + '.apx-tunnel__alt-name{font-weight:600;font-size:15px}'
      + '.apx-tunnel__alt-fact{font-size:13px;color:#52605A}'
      + '.apx-tunnel__alt-price{font-family:var(--apx-font-mono,monospace);font-size:15px;margin-top:4px}'
      + '.apx-tunnel__micro a{color:#1F2A24}'
      + '@media(max-width:480px){.apx-tunnel__start{grid-template-columns:1fr}.apx-tunnel__alts{grid-template-columns:1fr}}'
      + '.apx-tunnel__honest{font-size:12px;color:#52605A;margin:10px 0 0}'
      + '.apx-tunnel__offer{margin-top:24px;border:1px solid #DCE3DC;border-radius:14px;overflow:hidden}'
      + '.apx-tunnel__offer-head{padding:15px 18px;background:rgba(46,107,82,.06);border-bottom:1px solid #DCE3DC}'
      + '.apx-tunnel__offer-lead{font-size:13.5px;color:#52605A;margin:0 0 3px}'
      + '.apx-tunnel__offer-name{font-family:var(--apx-font-serif,Georgia,serif);font-size:22px;font-weight:400;margin:0;color:#1F2A24}'
      + '.apx-tunnel__offer-soon{font-size:12.5px;color:#9a3324;margin:6px 0 0;font-weight:600}'
      + '.apx-tunnel__offer-body{padding:15px 18px}'
      + '.apx-tunnel__reserve-cta{width:100%;margin-top:.5rem}'
      + '.apx-tunnel__micro{display:block;text-align:center;font-size:12.5px;color:#52605A;margin:10px 0 0}'
      + '.apx-tunnel__micro b{color:#1F2A24}'
      + '.apx-tunnel__disc{font-size:10.5px;color:#52605A;margin:20px 0 0;line-height:1.5}'
      + '@media(max-width:480px){.apx-tunnel__h1{font-size:24px}.apx-tunnel__step{grid-template-columns:70px 1fr;gap:10px}.apx-tunnel__proof{grid-template-columns:1fr}}';
    var el = document.createElement('style');
    el.id = 'apx-tunnel-styles';
    el.textContent = css;
    document.head.appendChild(el);
  }

  // ============================================================
  // UPSELL STYLES (injectes une fois)
  // ============================================================

  function injectUpsellStyles() {
    if (document.getElementById('apx-upsell-styles')) return;
    var css = ''
      + '.apx-upsell{max-width:640px;margin:0 auto;text-align:left}'
      + '.apx-upsell__name{margin:0 0 .25rem}'
      + '.apx-upsell__soon{color:#9a3324;margin:0 0 .75rem}'
      + '.apx-upsell__legend{margin:.5rem 0;opacity:.7}'
      + '.apx-upsell__tiers{display:flex;flex-direction:column;gap:.5rem}'
      + '.apx-upsell__tier{position:relative;display:flex;align-items:center;justify-content:space-between;gap:1rem;width:100%;padding:.8rem 1rem;border:1.5px solid rgba(20,40,80,.18);background:#fff;cursor:pointer;text-align:left;transition:border-color .15s,box-shadow .15s,background .15s}'
      + '.apx-upsell__tier:hover{border-color:var(--apx-quiz-pillar,#1A4A90)}'
      + '.apx-upsell__tier--active{border-color:var(--apx-quiz-pillar,#1A4A90);background:rgba(46,107,82,.06);box-shadow:inset 0 0 0 1px var(--apx-quiz-pillar,#1A4A90)}'
      + '.apx-upsell__tier--best{border-color:var(--apx-quiz-pillar,#1A4A90)}'
      + '.apx-upsell__tier-main{display:flex;flex-direction:column;gap:.2rem;min-width:0}'
      + '.apx-upsell__tier-label{font-family:var(--apx-font-mono,\'Space Mono\',monospace);font-size:.75rem;letter-spacing:.05em;text-transform:uppercase;color:#0A0E1A}'
      + '.apx-upsell__tier--active .apx-upsell__tier-label{color:var(--apx-quiz-pillar,#1A4A90)}'
      + '.apx-upsell__tier-save{font-family:var(--apx-font-mono,\'Space Mono\',monospace);font-size:.625rem;letter-spacing:.03em;color:var(--apx-quiz-pillar,#1A4A90)}'
      + '.apx-upsell__tier-price{font-family:var(--apx-font-serif,\'Cormorant Garamond\',Georgia,serif);font-size:1.4rem;font-weight:500;color:#0A0E1A;white-space:nowrap}'
      + '.apx-upsell__tier-flag{position:absolute;top:-.6rem;right:.75rem;background:var(--apx-quiz-pillar,#1A4A90);color:#fff;font-family:var(--apx-font-mono,\'Space Mono\',monospace);font-size:.5625rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:.15rem .45rem;border-radius:2px}'
      + '.apx-upsell__addon{display:flex;align-items:flex-start;gap:.5rem;margin:1rem 0;padding:.75rem;border:1px dashed rgba(0,0,0,.2);border-radius:8px;cursor:pointer;font-size:.9rem}'
      + '.apx-upsell__addon input{margin-top:.2rem}'
      + '.apx-upsell__footer{display:flex;flex-wrap:wrap;align-items:center;gap:.75rem;margin-top:.5rem}'
      + '.apx-upsell__total{margin:0;font-size:1.05rem}'
      + '.apx-upsell__cta{flex:1 1 auto}'
      + '.apx-upsell__view{font-size:.82rem;text-decoration:underline;opacity:.75}'
      + '@media(max-width:480px){.apx-upsell__tier{padding:.7rem .85rem}.apx-upsell__tier-price{font-size:1.2rem}}';
    var el = document.createElement('style');
    el.id = 'apx-upsell-styles';
    el.textContent = css;
    document.head.appendChild(el);
  }

  // ============================================================
  // PROGRESS
  // ============================================================

  function updateProgress(step, complete) {
    var pct = complete ? 100 : Math.round((step / state.totalSteps) * 100);
    if (elProgressBar) {
      elProgressBar.style.width = pct + '%';
    }
    var progressWrap = elProgressBar && elProgressBar.closest('[role="progressbar"]');
    if (progressWrap) progressWrap.setAttribute('aria-valuenow', pct);

    if (elProgressLabel) {
      if (complete) {
        elProgressLabel.textContent = 'Your result';
      } else if (step >= state.totalSteps) {
        elProgressLabel.textContent = 'Your result';
      } else {
        elProgressLabel.textContent = 'Question ' + step + ' of 7';
      }
    }
  }

  // ============================================================
  // PILLAR COLOR
  // ============================================================

  function setPillarColor(pillarKey) {
    var color = PILLAR_COLORS[pillarKey] || PILLAR_COLORS['default'];
    document.documentElement.style.setProperty('--apx-quiz-pillar', color);
  }

  // ============================================================
  // TRACKING
  // ============================================================

  // dataLayer (GTM / GA4) : jamais d'email ni de nom dans les parametres.
  function pushDL(eventName, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: eventName };
      var p = params || {};
      Object.keys(p).forEach(function (k) { if (k !== 'email' && k !== 'first_name') o[k] = p[k]; });
      window.dataLayer.push(o);
    } catch (e) {}
  }

  function trackEvent(eventName, params) {
    var p = params || {};
    // Meta Pixel
    if (typeof window.fbq === 'function') {
      try { window.fbq('trackCustom', eventName, p); } catch (e) {}
    }
    // GA4
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', eventName, p); } catch (e) {}
    }
    // Shopify analytics
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(eventName, p); } catch (e) {}
    }
  }

  // ============================================================
  // UI HELPERS
  // ============================================================

  function showQuestions() {
    if (elQuestions) elQuestions.hidden = false;
    if (elGate && !state.resultShown) elGate.hidden = true;
  }

  function showEmailError(msg) {
    if (elEmailError) {
      elEmailError.textContent = msg;
      elEmailError.hidden = false;
    }
    if (elEmailInput) {
      elEmailInput.setAttribute('aria-invalid', 'true');
      elEmailInput.classList.add('apx-quiz-gate__input--error');
    }
  }

  function hideEmailError() {
    if (elEmailError) elEmailError.hidden = true;
    if (elEmailInput) {
      elEmailInput.removeAttribute('aria-invalid');
      elEmailInput.classList.remove('apx-quiz-gate__input--error');
    }
  }

  function showError(msg) {
    if (elError) elError.hidden = false;
    if (elErrorMsg) elErrorMsg.textContent = msg || 'Something went wrong. Please try again.';
  }

  function hideError() {
    if (elError) elError.hidden = true;
    if (elGate) elGate.hidden = false;
  }

  function setGateLoading(loading) {
    if (!elGateSubmit) return;
    var labelEl = elGateSubmit.querySelector('.apx-quiz-gate__submit-label');
    var spinnerEl = elGateSubmit.querySelector('.apx-quiz-gate__submit-spinner');
    if (loading) {
      elGateSubmit.disabled = true;
      if (labelEl) labelEl.textContent = 'Sending...';
      if (spinnerEl) spinnerEl.hidden = false;
    } else {
      elGateSubmit.disabled = false;
      if (labelEl) labelEl.textContent = 'Email me my result';
      if (spinnerEl) spinnerEl.hidden = true;
    }
  }

  function showResultFakeSuccess() {
    // Robot (honeypot rempli) : on affiche "Sent." sans rien envoyer.
    showGateDone();
  }

  // ============================================================
  // UTILITIES
  // ============================================================

  function validateEmail(email) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
  }

  function getUrlParam(name) {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function getDevice() {
    var w = window.innerWidth;
    if (w < 768) return 'mobile';
    if (w < 1024) return 'tablet';
    return 'desktop';
  }

  function getBundleSlug(personaId, chronotype) {
    if (personaId !== 'marcus' || !chronotype) return '';
    var map = { lion: 'ours-foundation-daily', ours: 'ours-foundation-daily', loup: 'loup-night-edge', dauphin: 'dauphin-reset-protocol' };
    return map[chronotype] || '';
  }

  function saveState() {
    safeLocalStorageSet(STORAGE_KEY_STATE, {
      currentStep: state.currentStep,
      answers: state.answers,
      scores: state.scores,
      chronotype: state.chronotype
    });
  }

  function safeLocalStorageGet(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function safeLocalStorageSet(key, value) {
    try {
      if (value === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (e) {}
  }

  // ============================================================
  // FALLBACK CONFIG (si apex-quiz-config.json inaccessible)
  // ============================================================

  function getInlineFallbackConfig() {
    return {
      quiz_id: 'apexzen-persona-v1',
      email_gate_step: 8,
      questions: [
        {
          id: 'q1',
          label: 'What best describes your role right now?',
          sublabel: 'We calibrate the protocol to your actual output demands.',
          options: [
            { id: 'vp_director', label: 'VP, Director, or C-suite at a scaleup (50+ people)', weight: { marcus: 3 } },
            { id: 'founder_ceo', label: 'Founder or CEO running my own company', weight: { marcus: 1, jessica: 3 } },
            { id: 'senior_ic', label: 'Senior individual contributor or staff engineer', weight: { marcus: 2 } },
            { id: 'pre50_longevity', label: 'Pre-50, focused on longevity - no employer role', weight: { david: 3 } }
          ]
        },
        {
          id: 'q2',
          label: 'Are you currently pregnant or breastfeeding?',
          sublabel: 'Some adaptogens and nootropics are contraindicated. We need to know.',
          options: [
            { id: 'no', label: 'No', weight: { continue: 1 } },
            { id: 'postpartum', label: 'Postpartum or breastfeeding', weight: { sarah: 3 } },
            { id: 'pregnant', label: 'Currently pregnant', weight: { waitlist_prenat: 5 } }
          ]
        },
        {
          id: 'q3',
          label: 'Do you track sleep or HRV with a wearable?',
          sublabel: 'Helps us calibrate recovery recommendations.',
          options: [
            { id: 'yes_oura_whoop', label: 'Yes - Oura, Whoop, or similar', weight: { marcus: 2, david: 2, jessica: 1 } },
            { id: 'yes_apple', label: 'Yes - Apple Watch or Fitbit', weight: { marcus: 1, jessica: 1, david: 1 } },
            { id: 'no_wearable', label: 'No wearable', weight: {} }
          ]
        },
        {
          id: 'q4',
          label: 'How does your typical work day run?',
          sublabel: 'Chronotype alignment is the foundation of the protocol.',
          options: [
            { id: 'early_riser', label: 'Up by 5:30-6am, peak focus before 10am', chronotype: 'lion', weight: { marcus: 2, jessica: 2, david: 1 } },
            { id: 'standard', label: 'Up by 7-8am, peak focus mid-morning', chronotype: 'ours', weight: { marcus: 2, jessica: 1, david: 2 } },
            { id: 'late_peak', label: 'Slow start, peak focus after 2pm', chronotype: 'loup', weight: { marcus: 1, jessica: 2, david: 1 } },
            { id: 'fragmented', label: 'Fragmented - calls, travel, time zones', chronotype: 'dauphin', weight: { marcus: 3, jessica: 1 } }
          ]
        },
        {
          id: 'q5',
          label: 'Do you have children under 5 at home?',
          sublabel: 'Affects sleep architecture and cortisol recovery baseline.',
          options: [
            { id: 'yes_under5', label: 'Yes', weight: { marcus: 1, sarah: 1 } },
            { id: 'no_under5', label: 'No', weight: {} }
          ]
        },
        {
          id: 'q6',
          label: 'What is your primary performance goal right now?',
          sublabel: 'We weight the stack toward your stated priority.',
          options: [
            { id: 'stress_recovery', label: 'Reduce stress and recover faster', pillar: 'stress', weight: { marcus: 2, sarah: 2, jessica: 1 } },
            { id: 'sleep_quality', label: 'Improve sleep quality and onset', pillar: 'sleep', weight: { marcus: 2, david: 2, jessica: 1 } },
            { id: 'focus_energy', label: 'Sustain focus and cognitive energy', pillar: 'focus', weight: { marcus: 3, jessica: 3, david: 1 } },
            { id: 'longevity_base', label: 'Build a longevity baseline (cardiovascular, hormonal)', pillar: 'cardio', weight: { david: 3, marcus: 1 } }
          ]
        },
        {
          id: 'q7',
          label: 'Annual household income - roughly?',
          sublabel: 'Helps us size the protocol recommendation honestly.',
          options: [
            { id: 'under_80k', label: 'Under $80k', weight: { david: 1 } },
            { id: '80k_150k', label: '$80k - $150k', weight: { marcus: 1, jessica: 1, david: 2 } },
            { id: '150k_300k', label: '$150k - $300k', weight: { marcus: 2, jessica: 3, david: 1 } },
            { id: 'above_300k', label: '$300k+', weight: { marcus: 3, jessica: 2, david: 1 } }
          ]
        }
      ]
    };
  }

  // ============================================================
  // BOOT
  // ============================================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
